(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["royale-watch-swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('royale-watch-swatches')) {
    customElements.define('royale-watch-swatches', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-url]');
          if (button && this.contains(button) && !button.disabled) this.select(button);
        });
        const first = this.querySelector('button:not(:disabled)');
        if (first) this.select(first);
      }
      select(button) {
        const card = this.closest('.product-card-wrapper');
        if (!card) return;
        this.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        card.querySelectorAll('a.product-link').forEach(link => { link.href = button.dataset.url; });
        const image = card.querySelector('.product-first-image img');
        if (image) {
          image.removeAttribute('srcset');
          image.src = button.dataset.image;
          image.alt = button.dataset.alt;
        }
        const price = card.querySelector('.price');
        if (price) {
          const amount = document.createElement('span');
          amount.className = 'price-item price-item--regular';
          amount.textContent = button.dataset.price;
          price.replaceChildren(amount);
          price.classList.remove('price--on-sale');
        }
        this.querySelector('.royale-watch-swatches__reference').textContent = button.dataset.sku;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
